module.exports = __webpack_public_path__ + "img/partner-list-5.033e96fc.png";